export default {
  envelope_picture_number: {
    icon: 'icon-action-foto',
    text: 'Envelope Picture Requests',
    shortcut: 'envelope_picture_requested'
  },
  expedited_forward_number: {
    icon: 'icon-action-forward-expedited',
    // icon: 'icon-action-urgent-request',
    text: 'Expedited Forward Requests',
    shortcut: 'expedited_forward_requested'
  },
  forward_number: {
    icon: 'icon-action-forward',
    text: 'Forward Requests',
    shortcut: 'forward_requested'
  },
  mark_as_junk_number: {
    icon: 'icon-action-spam',
    text: 'Junk Mail',
    shortcut: 'mark_as_junk'
  },
  trash_number: {
    icon: 'icon-action-trash',
    text: 'Junk Requests',
    shortcut: 'trash_requested'
  },
  mark_as_pick_up_number: {
    icon: 'icon-action-mail-pick',
    text: 'Approve Mail as Picked Up',
    shortcut: 'mark_as_pick_up_requested'
  },
  pick_up_number: {
    icon: 'icon-action-mail-pick-customer',
    text: 'Pick Up Requests',
    shortcut: 'pick_up_requested'
  },
  same_day_scan_number: {
    icon: 'icon-action-scan-expedited',
    // icon: 'icon-action-urgent-request',
    text: 'Same Day Scan Requests',
    shortcut: 'same_day_scan_requested'
  },
  scans_number: {
    icon: 'icon-action-scan',
    text: 'Scan Requests',
    shortcut: 'scan_requested'
  },
  shred_number: {
    icon: 'icon-action-shred',
    text: 'Shred Requests',
    shortcut: 'shred_requested'
  },
  two_days_scan_number: {
    icon: 'icon-action-scan-expedited-2',
    // icon: 'icon-action-urgent-request',
    text: 'Two Days Scan Requests',
    shortcut: 'two_days_scan_requested'
  },
  check_deposit_number: {
    icon: 'icon-action-check-deposit-req',
    text: 'Check Deposit Requests',
    shortcut: 'check_deposit_requested'
  },
  stored_number: {
    icon: 'icon-action-stored-mail',
    text: 'Stored',
    shortcut: 'stored'
  },
}